import React from 'react';
import FeatherIcon from 'feather-icons-react';
import { func } from 'prop-types';

import './coupon.scss';

function Coupon({ onButtonClick }) {
  return (
    <div className="coupon row">
      <div className="d-none d-md-block col-lg-1 item">
        <div className="icon">
          <FeatherIcon icon="percent" />
        </div>
      </div>
      <div className="col-12 col-md-8 px-md-5">
        <h3>Save 20 to 25% in Hidden Costs</h3>
        <p className="description">
          Most home interior projects run over budget & never finish on time. Our cost estimation
          tool will provide reliable cost estimates & project time-lines, so you can save both money
          & time!
        </p>
      </div>
      <div className="col-12 col-md-2">
        <button
          type="button"
          className="btn btn-outline-light btn-lg rounded check-now"
          onClick={onButtonClick}
        >
          Get estimate
        </button>
      </div>
    </div>
  );
}

Coupon.propTypes = {
  onButtonClick: func.isRequired,
};

Coupon.defaultProps = {};

export { Coupon };
